<template>
  <div class="text-end">
    <span class="badge badge-sm bg-gradient-primary">Azul</span>
  </div>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr class="text-center">
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Plazo
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Interés regular
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Interés sin enganche
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Valor residual
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Agregado Seguro
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          ></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          v-for="interes in interesesAzul"
          :key="interes.id"
        >
          <td class="align-middle">
            <span class="text-dark text-xs font-weight-bold"
              >{{ interes.plazo }} Meses</span
            >
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold">{{
              interes.regular
            }}</span>
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold">{{
              interes.sin_enganche
            }}</span>
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold"
              >{{ interes.residual }}%</span
            >
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold"
              >{{ interes.seguro_agregado }}%</span
            >
          </td>
          <td class="align-middle">
            <button
              class="text-secondary font-weight-bold text-xs btn-xs mb-0 btn btn-link p-0"
              @click="openModal(interes)"
            >
              <i class="ri-pencil-line me-1"></i>Modificar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr />
  <div class="text-end">
    <span class="badge badge-sm bg-gradient-light text-dark opacity-7"
      >Platino</span
    >
  </div>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr class="text-center">
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Plazo
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Interés regular
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Interés sin enganche
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Valor residual
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          >
            Agregado Seguro
          </th>
          <th
            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
          ></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="text-center"
          v-for="interes in interesesPlatino"
          :key="interes.id"
        >
          <td class="align-middle">
            <span class="text-dark text-xs font-weight-bold"
              >{{ interes.plazo }} Meses</span
            >
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold">{{
              interes.regular
            }}</span>
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold">{{
              interes.sin_enganche
            }}</span>
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold"
              >{{ interes.residual }}%</span
            >
          </td>
          <td class="align-middle">
            <span class="text-secondary text-xs font-weight-bold"
              >{{ interes.seguro_agregado }}%</span
            >
          </td>
          <td class="align-middle">
            <button
              class="text-secondary font-weight-bold text-xs btn-xs mb-0 btn btn-link p-0"
              @click="openModal(interes)"
            >
              <i class="ri-pencil-line me-1"></i>Modificar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">
            {{ plazo }} meses -
            <small class="text-xs text-secondary"
              >Cliente {{ tipo_cliente }}</small
            >
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="Close"
          ></button>
        </div>
        <form method="POST" @submit.prevent="updateInteres" id="formInteres">
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-12">
                <label>Interés regular</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model="interes_regular"
                  name="interes_regular"
                  required
                />
              </div>
              <div class="form-group col-12">
                <label>Interés sin enganche</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model="interes_sin_enganche"
                  name="interes_sin_enganche"
                  required
                />
              </div>
              <div class="form-group col-12">
                <label>Valor residual</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model="valor_residual"
                  name="valor_residual"
                  required
                />
              </div>
              <div class="form-group col-12">
                <label>Seguro agregado</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model="seguro_agregado"
                  name="seguro_agregado"
                  required
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              type="submit"
              class="btn bg-gradient-primary btn-xs"
              :disabled="isLoading"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Guardar
            </button>
            <button
              type="button"
              class="btn bg-gradient-danger btn-xs"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { showToast, exceptionRequestMsg } from "@/assets/js/util";
import appApi from "@/services/api";
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
import { mapActions } from "vuex";

export default {
  props: {
    interesesAzul: {
      type: Object,
      required: true,
    },
    interesesPlatino: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      id: "",
      plazo: "",
      interes_regular: "",
      interes_sin_enganche: "",
      valor_residual: "",
      tipo_cliente: "",
      seguro_agregado: "",
      arrendamiento_id: this.$route.params.arrendamiento_id,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions("intereses", ["fetchInteresesByArrendamiento"]),
    openModal(interes) {
      const {
        id,
        plazo,
        regular,
        residual,
        sin_enganche,
        tipo_cliente,
        seguro_agregado,
      } = interes;

      this.plazo = plazo;
      this.id = id;
      this.interes_regular = regular;
      this.interes_sin_enganche = sin_enganche;
      this.valor_residual = residual;
      this.tipo_cliente = tipo_cliente;
      this.seguro_agregado = seguro_agregado;

      const myModal = new bootstrap.Modal(
        document.getElementById("staticBackdrop")
      );

      myModal.show();
    },
    async updateInteres() {
      this.isLoading = true;
      const form = document.getElementById("formInteres");
      const formData = new FormData(form);
      formData.append("_method", "PUT");
      try {
        const response = await appApi().post(
          `arrendamientos/detalle/interes/${this.id}/update`,
          formData
        );
        const { status, message } = response.data;

        this.isLoading = false;

        if (!status) {
          showToast(message, "error");
          return;
        }

        this.$refs.Close.click();
        this.fetchInteresesByArrendamiento(this.arrendamiento_id);
        showToast(message, "success");
      } catch (e) {
        this.isLoading = false;
        exceptionRequestMsg(e);
      }
    },
  },
};
</script>

<style></style>
